module.exports = __webpack_public_path__ + "img/Guangxi-power.32775144.png";